import { Controller } from '@hotwired/stimulus'
import {
  beginLessonSearchLoadingProgress,
  endLessonSearchLoadingProgress,
} from '../lib/lesson_search_loading'

const DEFAULT_LABEL = 'All lessons'

// Direct discovery links start a fresh, potentially slow library request. Show
// the same results-shaped shell used by in-page search before Turbo begins the
// visit. Primary Lessons navigation deliberately does not use this controller:
// it restores the last cached library snapshot instead.
export default class extends Controller {
  static targets = ['shell']

  connect() {
    this.boundReset = this.reset.bind(this)
    document.addEventListener('turbo:before-cache', this.boundReset)
    document.addEventListener('turbo:fetch-request-error', this.boundReset)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.boundReset)
    document.removeEventListener('turbo:fetch-request-error', this.boundReset)
  }

  show(event) {
    if (!this.hasShellTarget || !this.primaryNavigationClick(event)) return

    const label = event.currentTarget?.dataset?.lessonLibraryLoadingLabel?.trim() || DEFAULT_LABEL
    const queryLabel = this.shellTarget.querySelector('[data-lesson-search-loading-query]')
    if (queryLabel) queryLabel.textContent = label

    this.shellTarget.classList.remove('hidden')
    this.shellTarget.classList.add('is-active')
    this.shellTarget.setAttribute('aria-hidden', 'false')
    beginLessonSearchLoadingProgress(this.shellTarget)
  }

  reset() {
    if (!this.hasShellTarget) return

    this.shellTarget.classList.remove('is-active')
    this.shellTarget.classList.add('hidden')
    this.shellTarget.setAttribute('aria-hidden', 'true')
    endLessonSearchLoadingProgress(this.shellTarget)
  }

  primaryNavigationClick(event) {
    if (event.button !== undefined && event.button !== 0) return false
    return !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
  }
}
